// extracted by mini-css-extract-plugin
export default {"emptyCartIcon":"empty-cart__emptyCartIcon__Yugp6"};